// src/Paginas/BotonWhatsapp.jsx
import React from 'react';

const BotonWhatsapp = ({ 
  numero = '50687901553', 
  producto, 
  children, 
  className = '',
  personalizado = false,
  style = {},
  onMouseEnter,
  onMouseLeave,
  ...props 
}) => {
  const generarMensaje = () => {
    if (personalizado) {
      return `Hola!%20Me%20gustaría%20pedir%20una%20vela%20personalizada%20🕯️%0A%0A¿Podrían%20darme%20más%20información%20sobre%20los%20aromas%20disponibles%20y%20los%20precios?%20🙏`;
    }
    
    return `Hola!%20👋%20Me%20interesa%20la%20*${producto.nombre}*%20🕯️%0A%0A` +
           `📋%20Detalles%20del%20producto:%0A` +
           `•%20Descripción:%20${producto.descripcion}%0A` +
           `•%20Precio:%20${producto.precio}%0A` +
           `¿Podrían%20darme%20más%20información?%20🙏`;
  };

  return (
    <a
      href={`https://wa.me/${numero}?text=${generarMensaje()}`}
      target="_blank"
      rel="noopener noreferrer"
      className={`rounded-pill px-4 py-2 border-0 d-inline-flex align-items-center gap-2 text-decoration-none ${className}`}
      style={{
        backgroundColor: '#25D366',
        color: 'white',
        fontSize: '0.85rem',
        fontWeight: '600',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 15px rgba(37, 211, 102, 0.25)',
        ...style
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = '#1da851';
        e.target.style.transform = 'scale(1.05)';
        e.target.style.boxShadow = '0 6px 25px rgba(37, 211, 102, 0.35)';
        if (onMouseEnter) onMouseEnter(e);
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = '#25D366';
        e.target.style.transform = 'scale(1)';
        e.target.style.boxShadow = '0 4px 15px rgba(37, 211, 102, 0.25)';
        if (onMouseLeave) onMouseLeave(e);
      }}
      {...props}
    >
      {children}
    </a>
  );
};

export default BotonWhatsapp;